<template>
  <div id="chat-popup" :class="{ 'summary-sidebar-open': isMemberSidebarOpen }">
    <div :class="['chat-conversation-item', { opened: isChatPopupOpened }]">
      <div v-if="isChatPopupOpened" class="chat-conversation-item-header">
        <sword-button-wuk
          class="chat-conversation-item-header__close-button"
          theme="text"
          round
          size="small"
          icon="close"
          @click.native="closeChatPopup"
        />
      </div>
      <div v-show="isChatPopupOpened" class="chat-conversation-content">
        <iframe ref="iframeRef" :src="baseChatUrl" frameborder="0"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import store from '@/store'

import useChatIframe from '@/views/chat/composables/use-chat-iframe'

import SwordButtonWuk from '@ui-kit/components/buttons/SwordButton.vue'

export default {
  name: 'ChatPopup',
  components: { SwordButtonWuk },
  setup() {
    const isMemberSidebarOpen = computed(() => store.state.general.showAppGlobalModals.patientSummarySideBar)
    const isChatPopupOpened = computed(() => store.state.general.showAppGlobalModals.chatPopup)

    const accountUuid = computed(() => store.getters['patient/patientChatPopup/getAccountUuid'])
    const unit = computed(() => store.getters['patient/patientChatPopup/getUnit'])
    const channelId = computed(() => store.getters['patient/patientChatPopup/getChannelId'])

    const iframeEventsHandler = ({ data: { type: eventType, payload } }) => {

      // Drop event that come from different tab instances like chat in other tab
      if (eventType !== 'ready' && !isChatPopupOpened.value) return

      switch (eventType) {
        case 'open:summary-patient':
          store.dispatch('patient/patientSummary/openPatientSummarySideBar', payload.patientId)
          break
        case 'close:chat-popup':
          closeChatPopup()
          break
        case 'ready':
          iframeIsReady.value = true
          break
        default:
          break
      }
    }

    const {
      baseChatUrl,
      iframeRef,
      iframeIsReady,
      initialIframeSrc,
      resetSelectedChatChannelUrl,
    } = useChatIframe({ accountUuid, unit, channelId }, iframeEventsHandler, { enableIframeUrlUpdate: isChatPopupOpened })

    const closeChatPopup = () => {
      resetSelectedChatChannelUrl()
      store.dispatch('patient/patientChatPopup/closeChatPopup')
    }

    return {
      baseChatUrl,
      // Refs
      iframeRef,
      initialIframeSrc,
      // Computed
      isChatPopupOpened,
      isMemberSidebarOpen,
      // Methods
      closeChatPopup,
    }
  },
}
</script>

<style lang="scss" scoped>
#chat-popup {
  position: fixed;
  bottom: 1rem;
  right: 2rem;
  z-index: 50;
  display: flex;
  align-items: flex-end;
  gap: 1rem;

  &.summary-sidebar-open {
    right: 30rem;
  }
}

$chatHeight: 85vh;

.chat-conversation {
  &-item {
    box-shadow: 0px 6px 18px 0px rgba(0, 0, 0, 0.25);

    width: 265px;
    background: #fff;
    border-radius: 1rem;
    overflow: hidden;

    &.opened {
      width: 400px;
    }

    &-header {
      display: flex;
      justify-content: flex-end;
      padding: 1rem;
      border-bottom: 1px solid $context-color-7;

      &__close-button {
        position: absolute;
        top: 0;
        right: 0;

        ::v-deep {
          .sword-button-wuk.--small.round {
            margin: 0;
          }

          .sword-icon.svg-icon {
            height: 0.875rem !important;
            width: 0.875rem !important;
          }
        }
      }
    }
  }

  &-content {
    height: $chatHeight;
    display: flex;

    iframe {
      width: 100%
    }
  }
}
</style>
